export default angular.module("vesl.behaviors.programmatic-submit", []).directive("form", function() {
	return {
		require: "form",
		restrict: "E",
		link: function(scope, elem, attrs, formController) {
			formController.$submit = function() {
				formController.$setSubmitted();
				scope.$eval(attrs.ngSubmit);
			};
		}
	};
}).name;